import { render, staticRenderFns } from "./recoveryfile.vue?vue&type=template&id=84bcc6f8&scoped=true&"
import script from "./recoveryfile.vue?vue&type=script&lang=js&"
export * from "./recoveryfile.vue?vue&type=script&lang=js&"
import style0 from "./recoveryfile.vue?vue&type=style&index=0&id=84bcc6f8&lang=less&scoped=true&"
import style1 from "./recoveryfile.vue?vue&type=style&index=1&id=84bcc6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bcc6f8",
  null
  
)

export default component.exports